import React from 'react';
import { Form, Input, Button } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useStoreActions, useStoreState } from '../../store';
import { LocalizedText } from '../i18n/LocalizedText';

const formItemLayout = {
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 24,
      offset: 0,
    },
  },
};
export const ForgotPasswordForm = () => {
  const [form] = Form.useForm();
  const requestPasswordReset = useStoreActions((actions) => actions.session.requestPasswordReset);
  const i18n = useStoreState((state) => state.i18n.activeResources);
  //TODO: email validation
  const handleSubmit = (values: any) => {
    requestPasswordReset({
      email: values.email.trim(),
      subject: i18n['account.resetPassword.subject'],
      message: i18n['account.resetPassword.message'],
    })
      .then((res) => {
        console.log(res);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <Form form={form} onFinish={handleSubmit} {...formItemLayout}>
      <Form.Item
        style={{ marginBottom: 10 }}
        name="email"
        normalize={(value: string) => value.trim()}
        rules={[{ required: true, message: <LocalizedText token="registration.validation.emailRequired" /> }]}
      >
        <Input prefix={<MailOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder={i18n['account.email']} />
      </Form.Item>
      <Form.Item style={{ marginBottom: 0, marginTop: '20px' }} {...tailFormItemLayout}>
        <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
          <LocalizedText token="common.submit" />
        </Button>
      </Form.Item>
    </Form>
  );
};
